// ======================================================================
// File Name       : ContentDrillContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Table, Col, Tab, Tabs, Form } from 'react-bootstrap';
import ContentDrillSearch from '../../components/content/ContentDrillSearch';
import ContentDrillList from '../../components/content/ContentDrillList';
import { searchDrillList, downloadDrillList } from '../../actions/content/ContentDrillAction';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA, DEFAULT_DATE_FORMAT_SERVER } from '../../constants/index';
import { DATA_AFFIILIATION_TYPE } from '../../constants/ContentConstant';
import { showExportCSVSuccessMessage } from '../../utils/index';
import * as Path from '../../constants/PathConstants';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import * as actionType from '../../constants/actionTypes/page';
import * as ICON from '../../constants/IconConstants';
import PaginationCustom from '../../components/Pagination';
import CustomLink from '../../components/button/CustomLink';

class ContentDrillContainer extends Component {
  constructor() {
    super();
    this.state = {
      drillSearchInfo: {
        drillSecernId: '',
        drillTitle: '',
        drillKind: '',
        convertStatus: '',
        startDate: '',
        endDate: '',
        dataAffiliationType: DATA_AFFIILIATION_TYPE.NOT_SELECT, // default value
        startPosition: 0, // default value
        ascendingDescendingSort: 0, // default value
        drillSortType: null, // default not sort
        returnMaxNum: RETURN_MAX_NUM,
        createdUserName: '', // Step 9.0.0
      },
      searchDrillList,
      drillListInfo: null,
      isAllowShowSearchMessage: false,
      currentSearch: {
        ascendingDescendingSort: 0, // default value
        drillSortType: null,
        dataAffiliationType: DATA_AFFIILIATION_TYPE.NOT_SELECT, // default value
      },
      isInit: true,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.onSearchData = this.onSearchData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.openFileExportConfirm = this.openFileExportConfirm.bind(this);
    this.onFileExportCancel = this.onFileExportCancel.bind(this);
    this.onFileExportOk = this.onFileExportOk.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.handleChangeRadioButton = this.handleChangeRadioButton.bind(this);
    this.validateData = this.validateData.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    if (this.props.parentPath === Path.CONTENT_DRILL_LIST) {
      this.setState({
        ...this.state,
        currentSearch: this.props.searchCondition,
        drillSearchInfo: this.props.searchCondition,
        isInit: true,
      });
    }
  }

  componentDidMount() {
    this.getDrillList();
  }

  componentWillReceiveProps(nextProps) {
    const { content } = nextProps;
    const { drillListInfo } = content;
    this.setState({
      drillListInfo,
    });
  }

  componentWillUnmount() {
    const searchCondition = this.state.currentSearch;
    searchCondition.startPosition = this.state.drillSearchInfo.startPosition;
    searchCondition.drillSortType = this.state.drillSearchInfo.drillSortType;
    searchCondition.ascendingDescendingSort = this.state.drillSearchInfo.ascendingDescendingSort;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: Path.CONTENT_DRILL_LIST,
      searchCondition,
    });
  }

  validateData() {
    if (this.refsToValidate) {
      return Object.keys(this.refsToValidate).every(
        ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
      );
    }
    return true;
  }

  /**
   * Get drill list when click button search
   */
  onSearchData() {
    const isValid = this.validateData();
    if (!isValid) {
      return;
    }
    const drillSearchInfo = {
      ...this.state.drillSearchInfo,
      ...{ startPosition: 0 },
      ...{ ascendingDescendingSort: 0 },
      ...{ drillSortType: null },
    };
    const currentSearch = {
      ...this.state.drillSearchInfo,
      ...(this.state.currentSearch = this.state.drillSearchInfo),
    };
    this.setState(
      {
        drillSearchInfo,
        currentSearch,
        isInit: false,
      },
      () => {
        this.handleSearch();
      },
    );
  }

  handleSearch() {
    const isValid = this.validateData();
    if (!isValid) {
      return;
    }
    this.getDrillList();
  }


  /**
     * Get drill list
     */
  getDrillList() {
    const param = {
      drillSearchInfo: {
        drillSecernId: this.state.currentSearch.drillSecernId || undefined,
        drillTitle: this.state.currentSearch.drillTitle || undefined,
        drillKind:
          this.state.currentSearch.drillKind !== ''
            ? Number.parseInt(this.state.currentSearch.drillKind, 10)
            : undefined,
        convertStatus:
          this.state.currentSearch.convertStatus !== ''
            ? Number.parseInt(this.state.currentSearch.convertStatus, 10)
            : undefined,
        dataAffiliationType:
          this.state.currentSearch.dataAffiliationType === DATA_AFFIILIATION_TYPE.NOT_SELECT
            ? undefined
            : this.state.currentSearch.dataAffiliationType,
        drillSortType: this.state.currentSearch.drillSortType < 0
          ? undefined : this.state.drillSearchInfo.drillSortType,
        ascendingDescendingSort: this.state.drillSearchInfo.ascendingDescendingSort,
        startPosition: this.state.drillSearchInfo.startPosition,
        returnMaxNum: RETURN_MAX_NUM,
        createdUserName: this.state.currentSearch.createdUserName || undefined, // Step 9.0.0
      },
    };
    if (this.state.currentSearch.startDate || this.state.currentSearch.endDate) {
      param.drillSearchInfo.regDate = {
        startDate: this.state.currentSearch.startDate
          ? this.state.currentSearch.startDate.startOf('day').format(DEFAULT_DATE_FORMAT_SERVER)
          : undefined,
        endDate: this.state.currentSearch.endDate
          ? this.state.currentSearch.endDate.endOf('day').format(DEFAULT_DATE_FORMAT_SERVER)
          : undefined,
      };
    }
    this.props.dispatch(searchDrillList(param)).then(() => {
      if (!this.state.isInit) {
        this.setState({ isAllowShowSearchMessage: true });
      }
    });
  }

  /**
     * Handle change for user input
     * @param {*} event
     */
  handleChange(event, data) {
    let drillSearchInfo;
    if (data === undefined) {
      const { name, value } = event.target;
      drillSearchInfo = { ...this.state.drillSearchInfo, ...{ [name]: value } };
    } else {
      drillSearchInfo = { ...this.state.drillSearchInfo, ...{ [event]: data } };
    }
    this.setState({ drillSearchInfo });
  }

  /**
   * Handle when select date change
   * @param {*} name
   * @param {*} value
   */
  handleTimeChange(name, value) {
    const drillSearchInfo = { ...this.state.drillSearchInfo, ...{ [name]: value } };
    this.setState({
      drillSearchInfo,
    });
  }

  /**
   * Handle when radio button change
   * @param {*} event
   */
  handleChangeRadioButton(event) {
    const { name, value } = event.target;
    const drillSearchInfo = {
      ...this.state.drillSearchInfo,
      ...{ [name]: Number.parseInt(value, 10) },
    };
    this.setState({
      drillSearchInfo,
    });
  }

  /**
    * Open dialog confirm export Zip file
    */
  openFileExportConfirm(mdContent, mdSize) {
    const isValid = this.validateData();
    if (!isValid) {
      return;
    }
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  /**
     * Handle on Cancel click to export Zip file
     */
  onFileExportCancel() {
    this.setState({ showModal: false });
  }

  /**
     * Handle on OK click to export Zip file
     */
  onFileExportOk() {
    // ToDo: send data  etc ....
    this.setState({ showModal: false });
    this.downloadDrillList();
  }

  /**
     * Get drill list
     */
  downloadDrillList() {
    const param = {
      drillInfo: {
        drillSecernId: this.state.drillSearchInfo.drillSecernId || undefined,
        drillTitle: this.state.drillSearchInfo.drillTitle || undefined,
        drillKind:
          this.state.drillSearchInfo.drillKind !== ''
            ? Number.parseInt(this.state.drillSearchInfo.drillKind, 10)
            : undefined,
        convertStatus:
          this.state.drillSearchInfo.convertStatus !== ''
            ? Number.parseInt(this.state.drillSearchInfo.convertStatus, 10)
            : undefined,
        dataAffiliationType:
          this.state.drillSearchInfo.dataAffiliationType === DATA_AFFIILIATION_TYPE.NOT_SELECT
            ? undefined
            : this.state.drillSearchInfo.dataAffiliationType,
        createdUserName: this.state.drillSearchInfo.createdUserName || undefined, // Step 9.0.0
      },
    };
    if (this.state.drillSearchInfo.startDate || this.state.drillSearchInfo.endDate) {
      param.drillInfo.regDate = {
        startDate: this.state.drillSearchInfo.startDate
          ? moment(this.state.drillSearchInfo.startDate).startOf('day').format(DEFAULT_DATE_FORMAT_SERVER)
          : undefined,
        endDate: this.state.drillSearchInfo.endDate
          ? moment(this.state.drillSearchInfo.endDate).endOf('day').format(DEFAULT_DATE_FORMAT_SERVER)
          : undefined,
      };
    }
    this.props.dispatch(downloadDrillList(param)).then(() => {
      showExportCSVSuccessMessage();
    });
  }

  /**
     * Pagination
     * @param {*} startPosition
     */
  getStartEndData(startPosition) {
    const isValid = this.validateData();
    if (!isValid) {
      return;
    }
    const drillSearchInfo = {
      ...this.state.drillSearchInfo,
      ...{ startPosition },
    };
    this.setState(
      {
        drillSearchInfo,
      },
      () => {
        this.handleSearch();
      },
    );
  }

  /**
     * Handle sorting data
     * @param {*} row
     */
  handleSortState(row) {
    const isValid = this.validateData();
    if (!isValid) {
      return;
    }
    const drillSearchInfo = {
      ...this.state.drillSearchInfo,
      drillSortType: row.sortBy,
      ascendingDescendingSort: row.sortState,
    };
    this.setState(
      { drillSearchInfo }, () => {
        this.getDrillList();
      },
    );
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { hoverIndex } = this.state;
    this.refsToValidate = [];
    const recordNum = this.state.drillListInfo ? this.state.drillListInfo.recordNum : 0;
    const drillList = this.state.drillListInfo ? this.state.drillListInfo.drillList : [];
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={drillList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Col sm={12} className="float-end padding-left-right-clear align-right">
          <CustomLink
            className="margin-right-7 link-authority bold inline-flex line-height-20"
            to={Path.CONTENT_DRILL_SKIN_LIST}
            text="スキン管理"
            icon={ICON.DRILL_SKIN}
          />
        </Col>
        <ContentDrillSearch
          {...this.state.drillSearchInfo}
          recordNum={this.state.drillListInfo ? this.state.drillListInfo.recordNum : 0}
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          startPosition={this.state.drillSearchInfo.startPosition}
          handleChange={this.handleChange}
          handleTimeChange={this.handleTimeChange}
          handleChangeRadioButton={this.handleChangeRadioButton}
          getStartEndData={this.getStartEndData}
          onSearchBtnClick={this.onSearchData}
          onExportBtnClick={this.openFileExportConfirm.bind(
            this,
            MessageTemplate.BULK_EXPORT,
            null,
          )}
        />
        <ContentDrillList
          drillListInfo={this.state.drillListInfo}
          handleSortState={this.handleSortState}
          drillSearchInfo={this.state.drillSearchInfo}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
        <Col sm={12} className="d-flex justify-content-center">
          <PaginationCustom
            recordNum={recordNum}
            startPosition={this.state.drillSearchInfo.startPosition}
            handlePageSelect={this.getStartEndData}
          />
        </Col>
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onFileExportCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onFileExportOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parentPath, searchCondition } = state.page;
  return ({
    ...{ content: state.content },
    parentPath,
    searchCondition,
  });
};

export default connect(mapStateToProps)(ContentDrillContainer);
